// extracted by mini-css-extract-plugin
export default {"alertCard":"AlertCard_alertCard__FzY0w"};